<template>
  <v-list dense two-line>
    <v-list-item
        :href="instructionSrc"
        target="_blank"
    >
      <v-list-item-avatar>
        <v-icon class="primary--text">mdi-information-outline</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="primary--text">
          Внимание, данная информация является демонстрационной
        </v-list-item-title>
        <v-list-item-subtitle class="primary--text">
          Ваши УЗы будут видеть актуальную информацию о выставленных счетах после установки ЛК в вашу группу
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon color="pink">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'DemoWarning',
  data () {
    return {
      instructionSrc: this.$API.APP_INSTRUCTION_URL
    }
  }
}
</script>

<style scoped>

</style>